module.exports = __webpack_public_path__ + "img/browser_firefoxmobile.b65a4744.svg";